import { useQuery as e } from "@maat/store-hooks";
import { listingsApi as t } from "@maat/api-main";
//#region src/listings/useWorkspaceIcalBlocksQuery.ts
var n = (n) => e({
	queryKey: [
		"listings",
		"workspace-ical-blocks",
		n.start_date,
		n.end_date
	],
	queryFn: () => t.getWorkspaceIcalBlocks(n),
	enabled: !!n.start_date && !!n.end_date,
	staleTime: 300 * 1e3
});
//#endregion
export { n as useWorkspaceIcalBlocksQuery };
